import { useSlate } from 'slate-react'

import { Button } from 'core-components/library/button'
import {
  AbsolutePopup,
  PopPaper,
  TPopupHorizontal,
  TPopupVertical,
  TVisibilityTrigger,
} from 'core-components/library/popup'
import { setColorMark } from 'core-components/library/richTextEditor/helpers/slateHelper'
import { FONT_COLORS_FORMATS } from 'core-components/library/richTextEditor/interface/custom-types'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor/interface/IToolbar'
import { TFontColors } from 'core-components/library/richTextEditor/interface/TFontColors'

import { TOOLBAR_TITLES } from '../../constants'

import { ColorSettingsPopup } from './ColorSettingsPopup'

interface IProps {
  disabled: boolean
  colors: TFontColors[]
  className?: string
  isBackgroundColor?: boolean
}

export const ColorsButton = (props: IProps) => {
  const editor = useSlate()

  const colorSetting = props.isBackgroundColor ? 'backgroundColor' : 'color'

  const onClick = (color?: FONT_COLORS_FORMATS) => {
    setColorMark(editor, colorSetting, color)
  }

  return (
    <>
      <AbsolutePopup
        horizontalStartPosition={TPopupHorizontal.Right}
        verticalStartPosition={TPopupVertical.Bottom}
        popupContent={() => {
          return (
            <PopPaper>
              <ColorSettingsPopup
                onClick={onClick}
                colors={props.colors}
                isBackgroundColor={props.isBackgroundColor}
              />
            </PopPaper>
          )
        }}
      >
        <Button
          disabled={props.disabled}
          color={'grey'}
          title={
            TOOLBAR_TITLES[
              props.isBackgroundColor ? TOOLBAR_BUTTONS.BackgroundColor : TOOLBAR_BUTTONS.Color
            ]
          }
          variant={'text'}
          iconButton={
            props.isBackgroundColor
              ? 'kbase kbase-editor-background-color'
              : 'kbase kbase-editor-font-color'
          }
        />
      </AbsolutePopup>
    </>
  )
}
